import { createContext } from "react";

/** The guide modal (#436): one per portal shell, opened from anywhere. */
export interface GuideModalApi {
  /** The guide shown in the modal (`?guide=` in the URL), or null. */
  openKey: string | null;
  openGuide: (key: string) => void;
  /** Close the modal: removes `?guide=` from the URL (replace). */
  closeGuide: () => void;
}

export const GuideModalContext = createContext<GuideModalApi | null>(null);
